import { useTheme, spacing } from "@repo/tokens";

export const useLogoutConfirmModalStyles = (isNarrowLayout: boolean) => {
  const { theme } = useTheme();

  return {
    logoutText: {
      ...theme.typography.title.large.regular,
      fontWeight: 500,
      color: theme.text.primary,
      textAlign: "center" as const,
      lineHeight: theme.typography.title.large.regular.lineHeight ?? "1.35",
      marginBottom: 28,
      paddingLeft: spacing[2],
      paddingRight: spacing[2],
    },

    logoutModalBody: {
      position: "relative" as const,
      width: "100%",
      boxSizing: "border-box" as const,
      paddingLeft: spacing[6],
      paddingRight: spacing[6],
      paddingTop: spacing[1],
      paddingBottom: isNarrowLayout ? 28 : spacing[6],
    },

    logoutModalClose: {
      position: "absolute" as const,
      right: isNarrowLayout ? spacing[8] : spacing[4],
      top: isNarrowLayout ? undefined : spacing[2],
      zIndex: 1,
      padding: isNarrowLayout ? 30 : spacing[2],
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },

    logoutIconSection: {
      display: "flex",
      flexDirection: "column" as const,
      alignItems: "center" as const,
      paddingTop: isNarrowLayout ? 80 : spacing[10],
      width: "100%",
    },

    logoutOutlineButton: {
      width: "100%",
      height: spacing[12],
      borderRadius: 9999,
      borderWidth: 1,
      borderStyle: "solid" as const,
      borderColor: theme.feedback.error,
      backgroundColor: theme.colors.background[50],
      display: "flex",
      justifyContent: "center" as const,
      alignItems: "center" as const,
      cursor: "pointer",
      boxSizing: "border-box" as const,
    },

    logoutOutlineButtonText: {
      ...theme.typography.title.medium.regular,
      color: theme.feedback.error,
      fontWeight: 500,
    },

    logoutCloseLink: {
      ...theme.typography.title.medium.regular,
      marginTop: spacing[5],
      color: theme.action.primary.default,
      fontWeight: 500,
      textAlign: "center" as const,
      cursor: "pointer",
    },

    overlayLogout: {
      justifyContent: "flex-end",
      alignItems: "center",
    },
  };
};
